<template>
  <b-container v-if="showNotEnough" class="my-5" fluid>
    <b-row class="not-enough-container py-5 position-relative">
      <button id="close-not-enough" class="close" @click="closeWildcard">×</button>
      <b-col class="not-enough" cols="12" md="8">
        <img
          src="https://cdn.vexels.com/img/seeker-man.png"
          :alt="$t('withoutResult.main.wildcard.seekerManAlt')"
          loading="lazy"
        />
        <div class="text-container">
          <p>
            {{
              $t('notEnoughResult.main.designRequestBlock.firstText', {
                dimension: getActualDimensionName
              })
            }}
            <span class="font-weight-bold">{{ actualSearch }}</span>
            {{ $t('notEnoughResult.main.designRequestBlock.secondText') }}
            <nuxt-link :to="requestLink" class="to-profile">
              {{ $t('notEnoughResult.main.designRequestBlock.link') }}
            </nuxt-link>
          </p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  data() {
    return {
      openNotEnough: true
    };
  },
  computed: {
    ...mapGetters('dimensions', ['getActualDimensionName']),
    ...mapState('search', ['searchResult', 'isSearching', 'wildcard']),
    actualSearch() {
      return this.$route.params.search ? this.$route.params.search.replace(/-/g, ' ') : '';
    },
    fewResults() {
      return (
        this.searchResult.length > 0 &&
        this.searchResult.length <= this.$g('SEARCH_NOT_ENOUGH_RESULTS')
      );
    },
    showNotEnough() {
      return !this.isSearching && this.openNotEnough && this.fewResults && !this.wildcard;
    },
    requestLink() {
      const link = this.$auth.loggedIn
        ? this.localePath('profile-my-requests-new')
        : this.$urlBuilder('landing', { uid: 'design-requests' });
      return link;
    }
  },
  methods: {
    closeWildcard() {
      this.openNotEnough = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#close-not-enough {
  position: absolute;
  right: 15px;
  top: 10px;
  font-weight: 400;
  font-size: 2em;

  &:focus {
    border: none;
    outline: none;
  }
}
.not-enough-container {
  border: 1px solid #d8d8d8;
  border-radius: 5px;
}
.not-enough {
  margin: auto;
  transition: 0.5s width;
  display: flex;
  align-items: center;
}
.not-enough img {
  width: 40%;
}
.not-enough .text-container {
  padding: 0 50px;
}
.not-enough .text-container p {
  font-size: 30px;
  color: #989898;
}
.not-enough .text-container p a {
  color: #3cd699;
  border-bottom: 2px solid #3cd699;
}

@media all and (max-width: 1500px) {
  .not-enough {
    width: 70%;
  }
}
@media all and (max-width: 1200px) {
  .not-enough {
    width: 80%;
  }
  .not-enough .text-container {
    padding: 0 0 0 50px;
  }
  .not-enough .text-container p {
    font-size: 25px;
  }
}
@media all and (max-width: 1000px) {
  .not-enough {
    width: 90%;
  }
}
@media all and (max-width: 900px) {
  .not-enough {
    width: 100%;
  }
  .not-enough .text-container p {
    font-size: 20px;
  }
}
@media all and (max-width: 767px) {
  .not-enough {
    display: block;
    text-align: center;
  }
  .not-enough .text-container {
    padding: 0;
    margin: auto;
    margin-top: 25px;
    text-align: left;
  }
}
@media all and (max-width: 576px) {
  .not-enough .text-container {
    width: 95%;
  }
  .not-enough img {
    width: 60%;
  }
}
@media all and (max-width: 400px) {
  .not-enough img {
    width: 90%;
  }
}
</style>
